<va-mat-table>
  <mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="header-row">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.COLUMNS' | translate }}
      </mat-header-cell>
      <mat-cell [matTooltip]="col.headerRow" *matCellDef="let col">
        <span class="mobile-label">
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.COLUMNS' | translate }}
        </span>
        <span class="ellipsis">{{ col.headerRow }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="first-row">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.FIRST_ROW' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let col">
        <span class="mobile-label">
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.FIRST_ROW' | translate }}
        </span>
        {{ col.firstRow }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="mapping">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.MAP_TO' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let col">
        <app-bulk-import-mapper-row [headerRow]="col.headerRow"></app-bulk-import-mapper-row>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</va-mat-table>

@if (errors$ | async; as errors) {
  <mat-list class="errors">
    <div>
      <strong>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.ERRORS_ON_FOLLOWING_ROWS' | translate }}
      </strong>
    </div>
    @for (error of errors; track error) {
      <mat-list-item>
        <span href="#" class="span-tag tag">
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.ROW_NUMBER' | translate: { rowNumber: error.row } }}
          ({{ error.column }}) {{ error.message }}
        </span>
      </mat-list-item>
    }
    @if (show < errors?.length) {
      <a (click)="increaseShow()">
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.SHOW_MORE' | translate }}
      </a>
    }
    <section>
      <mat-checkbox class="example-margin" [(ngModel)]="proceedWithErrors">
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.SKIP_ROWS_WITH_ERRORS' | translate }}
      </mat-checkbox>
      <div>
        <mat-hint>
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.DOWNLOAD_CSV_WITH_INCOMPLETE_ACCOUNTS' | translate }}
        </mat-hint>
      </div>
      @if (!proceedWithErrors) {
        <mat-error>*{{ 'COMMON.REQUIRED' | translate }}</mat-error>
      }
    </section>
    @if (errors?.length > 0) {
      <a href="/manage-accounts/import-list/business-categories-csv" target="_blank">
        <mat-icon color="primary">save_alt</mat-icon>
        <span class="downloadLink">
          {{ 'USERS.BULK_IMPORT.DOWNLOAD_BUSINESS_CATEGORIES' | translate }}
        </span>
      </a>
    }
  </mat-list>
}

<div class="map-buttons">
  @if (errorMessage$ | async; as errorMessage) {
    <mat-error
      class="error mapperError"
      innerHTML="{{ errorMessage }}"
    ></mat-error>
  }
  <button
    mat-stroked-button
    color="secondary"
    matStepperPrevious
    type="button"
    data-action="clicked-back-field-mapper-bulk-import"
    >
    {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
  </button>
  <button
    [disabled]="uploading$ | async"
    mat-flat-button
    type="button"
    color="primary"
    (click)="uploadFileAndMapping()"
    style="vertical-align: top"
    data-testid="upload-file-and-mapping"
    data-action="clicked-next-field-mapper-bulk-import"
    >
    @if ((uploading$ | async) === false) {
      <span>
        {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
      </span>
    }
    @if (uploading$ | async) {
      <mat-spinner class="processing-spinner" [diameter]="30"></mat-spinner>
    }
  </button>
</div>
